import React, { ChangeEvent, forwardRef } from 'react';
import { FormField } from '@/shared/ui/form/form-field';
import { ExpireMonthInputProps } from '@/shared/ui/form/cvv-input';

export const ExpireInput = forwardRef<HTMLInputElement, ExpireMonthInputProps>(
  (props, ref) => {
    const { input, refNex, ...rest } = props;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
      const value = e.target.value;
      const digits = value.replace(/\D/g, '');
      const trimmed = digits.slice(0, 2);

      input.onChange(trimmed);

      if (trimmed.length === 2 && refNex) {
        (refNex as React.RefObject<HTMLInputElement>).current?.focus();
      }
    };

    return (
      <FormField
        {...rest}
        input={{
          ...input,
          onChange: handleChange,
          value: input.value || '',
        }}
        ref={ref}
        maxLength={2}
        inputMode="numeric"
      />
    );
  }
);
